import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import BaseAnalyticsBanner from '@/components/v2/BaseAnalyticsBanner.vue';
import BaseAnalyticsBannerContent from '@/components/v2/BaseAnalyticsBannerContent.vue';
import latestCustomersQuery from '@/plugins/graphql/queries/v2/ecommerce/today-latest-customers.gql';
import RouteParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import PerformanceListCountMixin from '@/helpers/vue_mixins/PerformanceListCountMixin';
import Avatar from '@/components/avatar/Index.vue';
let TodayLatestCustomers = class TodayLatestCustomers extends mixins(RouteParamsAppMixin, PerformanceListCountMixin) {
    constructor() {
        super(...arguments);
        this.section = `Today's Customers`;
        this.customersPath = {
            name: 'ecommerce-latest-customers',
        };
    }
    get showPagination() {
        return this.latestCustomers.edges.length >= 5;
    }
    defaultImage(recipient) {
        if (recipient.profilePic) {
            return recipient.profilePic;
        }
        if (recipient.platformOrigin === 'gcash') {
            return require('@/assets/images/GLIFE.png');
        }
        require('@/assets/images/chatgenie_default_avatar.png');
    }
};
TodayLatestCustomers = __decorate([
    Component({
        components: {
            Avatar,
            BaseAnalyticsBanner,
            BaseAnalyticsBannerContent,
        },
        apollo: {
            latestCustomers: {
                query: latestCustomersQuery,
                variables() {
                    return {
                        appUuid: this.appUUID,
                        withinDay: true,
                        limit: 5,
                    };
                },
                fetchPolicy: 'cache-and-network',
            },
        },
    })
], TodayLatestCustomers);
export default TodayLatestCustomers;
